import React from 'react';
import OrderListPage from './OrderListPage';

interface IProps {
  handleModalOpen: (data: any) => void;
  rowDetails: any;
  setRowDetails: any;
}

const KittingOrders = (props: IProps) => (
  <OrderListPage
    section="Product Kitting"
    emptyMessage="Nothing waiting for kitting."
    {...props}
  />
);

export default KittingOrders;
